var target = document.querySelector('#enormReviews');
// create an observer instance
var observer = new MutationObserver(function(mutations) {
  if (document.querySelector(".enreview_container-fluid")) {
    const e = document.querySelector(".accordion-detail-list");
    setTimeout(function(){
      const t = e.getBoundingClientRect().height;
      if(t > window.innerHeight){
        e.classList.add("bottom");
        e.classList.remove("top");
      }else{
        e.classList.add("top");
        e.classList.remove("bottom");
      }
    },2000)
  }
});

var config = { attributes: true, childList: true, characterData: true }
if (target) {
  observer.observe(target, config);
}

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', 'false');
  if(summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }
  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};
function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];
  removeTrapFocus();
  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function() {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function(event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }
    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = ['ARROWUP', 'ARROWDOWN', 'ARROWLEFT', 'ARROWRIGHT', 'TAB', 'ENTER', 'SPACE', 'ESCAPE', 'HOME', 'END', 'PAGEUP', 'PAGEDOWN']
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if(navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener('focus', () => {
    if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

    if (mouseClick) return;

    currentFocusedElement = document.activeElement;
    currentFocusedElement.classList.add('focused');

  }, true);
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input');
    this.changeEvent = new Event('change', { bubbles: true })

    this.querySelectorAll('button').forEach(
      (button) => button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === 'plus' ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
  };
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
    this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if(event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if(!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));
      summaryElement.nextElementSibling.removeEventListener('transitionend', addTrapFocus);
    }

    if (detailsElement === this.mainDetailsToggle) {
      if(isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        !reducedMotion || reducedMotion.matches ? addTrapFocus() : summaryElement.nextElementSibling.addEventListener('transitionend', addTrapFocus);
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach(details =>  {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);
    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    }

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.getElementById('shopify-section-header');
    this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
  }
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target.nodeName === 'MODAL-DIALOG') this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));

      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver(entries => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    this.sliderLastItem = this.sliderItemsToShow[this.sliderItemsToShow.length - 1];
    if (this.sliderItemsToShow.length === 0) return;
    this.slidesPerPage = Math.floor(this.slider.clientWidth / this.sliderItemsToShow[0].clientWidth);
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderLastItem.clientWidth) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(new CustomEvent('slideChanged', { detail: {
        currentPage: this.currentPage,
        currentElement: this.sliderItemsToShow[this.currentPage - 1]
      }}));
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0])) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderLastItem)) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (element.offsetLeft + element.clientWidth) <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition = event.currentTarget.name === 'next' ? this.slider.scrollLeft + (step * this.sliderLastItem.clientWidth) : this.slider.scrollLeft - (step * this.sliderLastItem.clientWidth);
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach(link => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach(link => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton = event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition = this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.slider.querySelector('.slideshow__slide').clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const button = item.querySelector('a');
      if (index === this.currentPage - 1) {
        if (button) button.removeAttribute('tabindex');
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (button) button.setAttribute('tabindex', '-1');
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition = this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);

  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options.map((option, index) => {
        return this.options[index] === option;
      }).includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGallery = document.getElementById(`MediaGallery-${this.dataset.section}`);
    if(mediaGallery){
      
    if($(window).width() < 749){
      $("#Slide-"+`${this.dataset.section}-${this.currentVariant.featured_media.id}`).show();
    }
      mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true);
    }
    // const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    // const newMediaModal = modalContent.querySelector( `[data-media-id="${this.currentVariant.featured_media.id}"]`);
    // modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({ }, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
      .then((response) => response.text())
      .then((responseText) => {
        const id = `price-${this.dataset.section}`;
        const html = new DOMParser().parseFromString(responseText, 'text/html')
        const destination = document.getElementById(id);
        const source = html.getElementById(id);
        let varaint_img = html.getElementById('selected_variant_img');
        $('.popop-cart-product-img').attr('src', varaint_img.innerHTML);
        let is_available = html.querySelector('button.product-form__submit').getAttribute('is_available');
        if( is_available.trim() == 'false'){
          $('.product-form__submit_buy_now').not('.popup-buy-now').addClass('hidden');
          $('.custom-buy-now-btn').addClass('hidden');
          $('.popup-buy-now').html('Sold out');
          $('.popup-buy-now').attr('disabled','disabled')
          $('.product-form__submit_mobile').html('Sold out');
          $('.product-form__submit_mobile').attr('disabled','disabled');
          $(".popup-add-to-cart").html('Sold out')
          $('.popup-add-to-cart').attr('disabled','disabled');
        }else{
          $('.product-form__submit_buy_now').removeClass('hidden');
          $('.custom-buy-now-btn').removeClass('hidden');
          $('.popup-buy-now').html('Buy Now');
          $('.popup-buy-now').attr('disabled', false);
          $('.product-form__submit_mobile').html('Add to cart');
          $('.product-form__submit_mobile').attr('disabled', false);
          $(".popup-add-to-cart").html('Confirm')
          $('.popup-add-to-cart').attr('disabled',false);
        }

        if (source && destination) destination.innerHTML = source.innerHTML;
        const price = document.getElementById(`price-${this.dataset.section}`);
        if (price){
          price.classList.remove('visibility-hidden');
          $('.cart-form-modal .pdt-price').html($(price).find('span.price-item').html());
        } 
        this.toggleAddButton(!this.currentVariant.available, window.variantStrings.soldOut);
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');

    if (!addButton) return;

    if (disable) {
      addButton.setAttribute('disabled', 'disabled');
      if (text){
        addButtonText.textContent = text;
        $('.product-form .product-form__submit_buy_now').attr('disabled', 'disabled').html(text).addClass('hidden');
      }

    } else {
      addButton.removeAttribute('disabled');
      addButtonText.textContent = window.variantStrings.addToCart;
      $('.product-form .product-form__submit_buy_now').attr('disabled', false).html('Buy Now').removeClass('hidden');
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('visibility-hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  // updateOptions() {
  //   const fieldsets = Array.from(this.querySelectorAll('fieldset'));
  //   this.options = fieldsets.map((fieldset) => {
  //     return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
  //   });
  // }

  updateOptions() {
  const fieldsets = Array.from(this.querySelectorAll('fieldset'));
  this.options = fieldsets.map((fieldset) => {
    const checkedRadio = Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked);
    return checkedRadio ? checkedRadio.value : Array.from(fieldset.querySelectorAll('input'))[0].value;
  });
}
 
}

customElements.define('variant-radios', VariantRadios);


$('.product .product__info-wrapper h1.product__title').on('click', function(){
  $(this).addClass('title-show');
})

//////////////////
var mySwiper = (function() {
  // Variables
  var $swiperContainer = $(".four-card_slider");

  function init($this) {
    // Swiper elements
    var $el = $this.find('.swiper-container'),
      navNext = $this.find('.swiper-button-next_4-card'),
      navPrev = $this.find('.swiper-button-prev_4-card');

    // Initialize Swiper
    var $swiper = new Swiper($el, {
      slidesPerView: 2,
      spaceBetween: 10,
      slidesPerGroup: 1,
      breakpoints: {
        320: {
          slidesPerView: 2.2,
          spaceBetween: 4,
        },
        768: {
          slidesPerView: 2,
          spaceBetween: 15,
        },
      },
      navigation: {
        nextEl: navNext,
        prevEl: navPrev,
      },
      freeMode: true,
    });
  }

  // events
  if ($swiperContainer.length) {
    $swiperContainer.each(function(i, Slider) {
      init($(Slider));
    });
  }
})();

// add to cart












$(document).ready(function(){
  $(".filter-menu > ul").on('click', '> li > .filter-menu-item', function(event) {
    var $fl = $(this);
    if($fl.next().hasClass('filter-submenu')){
      
      if($(this).closest('li').hasClass('menu-open')){
        $('.filter-menu > ul > li').find('.filter-submenu').slideUp();
        $('.filter-menu > ul > li').removeClass('menu-open');
      }
      else{
        $('.filter-menu > ul > li').find('.filter-submenu').slideUp();
        $(this).closest('li').find('.filter-submenu').stop().slideDown('slow');
        $(this).closest('li').addClass('menu-open').siblings('li').removeClass('menu-open');
      }
    }
  });

  $("#Search-In-Modal").click(function(e){
    e.preventDefault();
    e.stopPropagation();
    if($(this).hasClass('auto-val')){
      $(this).val('');
      $(this).removeClass('auto-val');
    }
  });
  $(".welcome-modal .welcome-popup-link").click(function(e){
    setWelcomeCookie();
  });
  var modal_welcome = document.querySelector(".welcome-modal");
  var closeButton_welcome = document.querySelector(".welcome-modal .close-button");
  function toggleModalWelcome() {
    if(modal_welcome){
      modal_welcome.classList.toggle("show-modal"); 
      $('body').toggleClass("no-scroll");
    }
  }
  function windowOnClickWelcome(event) {
    if (event.target === modal_welcome) {
      toggleModalWelcome();
      setWelcomeCookie();
    }
  }

  function setWelcomeCookie(){
    var now = new Date();
    now.setTime(now.getTime() + 1 * 3600 * 1000);
    document.cookie = "visited_status=true; expires=" + now.toUTCString() + "; path=/";
  }
  window.addEventListener("click", windowOnClickWelcome);
  if(closeButton_welcome){
    closeButton_welcome.addEventListener("click", toggleModalWelcome);
    closeButton_welcome.addEventListener("click", setWelcomeCookie);
  }

  var visited_status = getCookie("visited_status");
  if(visited_status !== "true"){ 
    setTimeout(function() {  
      toggleModalWelcome()
    }, 7000); 
  }
  function getCookie(cname) {
    let name = cname + "=";
    let ca = document.cookie.split(';');
    for(let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  $(".icon-eye").click(function(e){
    e.preventDefault();
    let type = $(this).siblings( "input" ).prop("type");
    if(type == 'text'){
      $(this).siblings( "input" ).prop("type" ,"password");
      $(".icon-eye.show").hide();
      $(".icon-eye.hide").removeClass('hidden').show();
    }
    if(type == "password"){
      $(this).siblings( "input" ).prop("type", "text");
      $(".icon-eye.show").removeClass('hidden').show();
      $(".icon-eye.hide").hide();
    }
  });

});

  /* Login Form modal */
  var modal = document.querySelector(".sign-in-form-modal");
  var trigger = document.querySelector(".signIn-form-btn");
  var trigger2 = document.querySelector(".signIn-form-btn-icon");
  var trigger3 = document.querySelector(".signIn-form-btn-mobile");
  var trigger4 = document.querySelector(".wishlist-form-btn-icon");
  var closeButton = document.querySelector(".sign-in-form-modal .close-button");
  var paylatermodal = document.querySelector(".paylater-modal");
  var paylaterbtn = document.querySelector(".paylater-btn");
  var paylaterclose = document.querySelector(".paylater-modal .close-button");

  function toggleModal() {
    modal.classList.toggle("show-modal");
    $('body').toggleClass("no-scroll");
    $(".sign-in-form-modal .errors").html('');
  }
  function togglepaylaterModal() {
    paylatermodal.classList.toggle("show-modal");
    $('body').toggleClass("no-scroll");
  }
  function hideRecoverForm(){
    $("#login").show();
    $("#login+div").show();
    $("#recover").hide();
    $("#recover+div").hide();
  }

  function windowOnClick(event) {
    if (event.target === modal) {
      toggleModal();
    }
  }
  if (trigger) {
    trigger.addEventListener("click", toggleModal);
    trigger.addEventListener("click", hideRecoverForm);
  }
  if (trigger2) {
    trigger2.addEventListener("click", toggleModal);
    trigger2.addEventListener("click", hideRecoverForm);
  }
  if (trigger3) {
    trigger3.addEventListener("click", toggleModal);
    trigger3.addEventListener("click", hideRecoverForm);
  }
  if (trigger4) {
    trigger4.addEventListener("click", toggleModal);
    trigger4.addEventListener("click", hideRecoverForm);
  }
  if (paylaterbtn) {
    //paylaterbtn.addEventListener("click", togglepaylaterModal);
  }
  if (closeButton) {
    closeButton.addEventListener("click", toggleModal);
    window.addEventListener("click", windowOnClick);
  } 
  if (paylaterclose) {
    paylaterclose.addEventListener("click", togglepaylaterModal);
    window.addEventListener("click", windowOnClick);
  } 
  
  //login form validation
  $('.popup-login-submit-btn').click(function (e) {
    $(".sign-in-form-modal .errors").html('');
    let login_email = $('.sign-in-form-modal #CustomerEmail').val();
    let login_password = $('.sign-in-form-modal #CustomerPassword').val();
    let is_valid = true;
    if (login_email == '') {
      $("#login_form_error_email").html("<p>Email can't be blank</p>");
      is_valid = false;
    } else {
      if (!ValidateEmail(login_email)) {
        $("#login_form_error_email").html("<p>Email is invalid</p>");
        is_valid = false;
      }
    }
    if (login_password == '') {
      is_valid = false;
      $("#login_form_error_password").html("<p>Password can't be blank</p>");
    }
    if (!is_valid) {
      e.preventDefault();
    }
  });
    //forgot password
  $('.sign-in-form-modal .forgot-passwrd').click(function(e){
    $("#recover_validation").html('');
    e.preventDefault();
    $("#login").hide();
    $("#login+div").hide();
    $("#recover").show();
    $("#recover+div").show();
  });
 //forgot password validation
$('.recover-btn').click(function(e){
  $("#recover_validation").html('');
  let email = $("#RecoverEmail").val();
  if(email == ''){
    e.preventDefault();
    $("#recover_validation").html("<p>Email can't be blank</p>");
  }
  else if(!ValidateEmail(email)){
    e.preventDefault();
    $("#recover_validation").html("<p>Email is invalid</p>");
  }
}); 

$(document).on('click','#enorm-paging',function(e){
   e.preventDefault();
   $('html, body').animate({
        scrollTop: $("#enormReviews").offset().top
    }, 50);
});

  function ValidateEmail(email) {
    var mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
    if (email.match(mailformat)) {
      return true;
    }
    else {
      return false;
    }
  }

  let register_modal = document.querySelector(".register-form-modal");
  var register_trigger = document.querySelector(".register-popup-toggle");
  var register_trigger2 = document.querySelector(".register-form-btn-header");
  var closeButton_register = document.querySelector(".register-form-modal .close-button");
  function toggleModalRegister() {
    // close login modal
    let login_modal = document.querySelector(".sign-in-form-modal");
    if (login_modal) {
      login_modal.classList.remove("show-modal");
    }
    register_modal.classList.toggle("show-modal");
    $('body').toggleClass("no-scroll");
    $(".register-form-modal .errors").html('');
  }
  if (register_trigger) {
    register_trigger.addEventListener("click", toggleModalRegister);
  }
  if (register_trigger2) {
    register_trigger2.addEventListener("click", toggleModalRegister);
  }
  if (closeButton_register) {
    closeButton_register.addEventListener("click", toggleModalRegister);

    window.addEventListener("click", windowOnClickRegister);
  }
  function windowOnClickRegister(event) {
    if (event.target === register_modal) {
      $('body').removeClass("no-scroll");
      toggleModalRegister();
    }
  }
  // register form validation
  $(".popup-register-btn").click(function (e) {

    let first_name = $(".register-form-modal #RegisterForm-FirstName").val();
    let last_name = $(".register-form-modal #RegisterForm-LastName").val();
    let reg_email = $(".register-form-modal #RegisterForm-email").val();
    let reg_password = $(".register-form-modal #RegisterForm-password").val();
    $('.register-form-modal .errors').html('');
    let is_valid = true;
    if (first_name == '') {
      $("#register_form__errors_first_name").html("<p>First name can't be blank</p>");
      is_valid =  false;
    }
    if (last_name == '') {
      $("#register_form__errors_last_name").html("<p>Last name can't be blank</p>");
      is_valid =  false;
    }
    if (reg_email == '') {
      $("#register_form__errors_email").html("<p>Email can't be blank</p>");
      is_valid =  false;
    } else {
      if (!ValidateEmail(reg_email)) {
        $("#register_form__errors_email").html("<p>Email is invalid</p>");
        is_valid =  false;
      }
    }
    if (reg_password == '') {
      $("#register_form__errors_password").html("<p>Password can't be blank</p>");
      is_valid =  false;
    }
    if (reg_password.length < 5) {
      $("#register_form__errors_password").html("<p>Password is too short (minimum is 5 characters)</p>");
      is_valid =  false;
    }
    if (!is_valid) {
      e.preventDefault();
    }
  });

  var cart_modal = document.querySelector(".cart-form-modal");
  var cart_closeButton = document.querySelector(".cart-form-modal .close-button");
  function toggleModalCart() {
    cart_modal.classList.toggle("show-modal");
    $('body').toggleClass("no-scroll");

    $('.cart-form-modal .product-form__buttons .popup-add-to-cart').show();
    $('.cart-form-modal .product-form__buttons .popup-buy-now').hide();
  }
  function windowOnClick_cart(event) {
    if (event.target === cart_modal) {
      //toggleModalCart();
      $(cart_closeButton).trigger('click');
    }
  }
  if (cart_closeButton) {
    cart_closeButton.addEventListener("click", toggleModalCart);
    window.addEventListener("click", windowOnClick_cart);
  }

$('.close-button').click(function(e){
  let forms = $(this).parentsUntil('.modal').find('form');
  forms.each(function(){
    $(this)[0].reset();
  })
});

$(document).ready(function(){
  $("#get_tabby_info, #buy-now-pay-btn").click(function(){

    let paylatermodal = document.querySelector(".paylater-modal");
    const btn = $(this);
    // btn.html('Loading...');
    btn.addClass('disabled');
    btn.attr('disabled','disabled');
    $('.tabby_before_load').show();
    $('.tabby_after_load').hide();
    const tabby_min = parseFloat($("#tabby_cart_add_more").data('tabby-min'));
    $.ajax({
      url: '/cart.js',
      type: 'GET',
      dataType: 'json',
      success: function(cart) {

        // btn.html('Learn more');
        btn.removeClass('disabled');
        btn.attr('disabled',false);
        $('.tabby_before_load').hide();
        $('.tabby_after_load').show();
        const cart_total = cart.total_price/100;
        $("#tabby_cart_total").html(cart_total +' '+ cart.currency);
        if(cart_total >= tabby_min){
          generateTabbyEmiInfo(cart);
          $("#tabby_cart_add_more").hide();
          $('.modal-body .installment').show();
        }
        else{
          $("#tabby_cart_add_more span").html( (tabby_min - cart_total) + ' ' + cart.currency );
          $("#tabby_cart_add_more").show();
          $('.modal-body .installment').hide();
        }
        paylatermodal.classList.toggle("show-modal");
        $('body').toggleClass("no-scroll");

      },
      error: function(xhr, status, error) {
        console.error('Error fetching cart details:', error);
      }
    });
  });
  generateTabbyEmiInfo = (cart)=>{
    // append html to #tabby_emi_table tbody
    const tabby_monthly_amount = removeDecimalIfZero ((cart.total_price/100 ) / 4);
    $("#tabby_montly_amount").html( tabby_monthly_amount + '/month')
    $("#tabby_total_amount").html( (cart.total_price/100) + ' ' +cart.currency );

    let tbody = '<tr><td>Today</td><td>'+tabby_monthly_amount+' '+ cart.currency +'</td></tr>';
    const nextThreeFormattedDates = getNextThreeDatesFormatted();
    nextThreeFormattedDates.forEach(date => {
      tbody += '<tr><td>'+date+'</td><td>'+tabby_monthly_amount+' '+ cart.currency +'</td></tr>';
    });
    $("#tabby_emi_table tbody").html(tbody);
  }

  function removeDecimalIfZero(num) {
    const formattedNum = num.toString().replace(/(\.[0-9]*[1-9])0+$/, '$1');
    return parseFloat(formattedNum);  // Convert the string back to a number
  }

  function getNextThreeDatesFormatted() {
    const today = new Date();
    const nextDates = [];
  
    for (let i = 1; i <= 3; i++) {
      const nextDate = new Date(today);
      nextDate.setMonth(today.getMonth() + i);
      nextDates.push(nextDate);
    }
  
    return nextDates.map(formatDate);
  }
  
  function formatDate(date) {
    const months = [
      'Jan', 'Feb', 'Mar', 'Apr',
      'May', 'Jun', 'Jul', 'Aug',
      'Sep', 'Oct', 'Nov', 'Dec'
    ];
  
    const day = date.getDate();
    const month = months[date.getMonth()];
    const year = date.getFullYear();
  
    const suffix = getDaySuffix(day);
  
    return `${day}${suffix} ${month}' ${year}`;
  }
  
  function getDaySuffix(day) {
    if (day >= 11 && day <= 13) {
      return 'th';
    }
    switch (day % 10) {
      case 1:
        return 'st';
      case 2:
        return 'nd';
      case 3:
        return 'rd';
      default:
        return 'th';
    }
  }

  var tabLinks = document.querySelectorAll('.mega-menu_tab .tablinks');
  var tabContent = document.querySelectorAll('.mega-menu_list .tabcontent');
  const allCatrgoryBtn = document.querySelector('.all-categories-btn');
  allCatrgoryBtn.addEventListener('mouseenter', function(){

    tabLinks.forEach(function (el) {
      el.classList.remove('active');
    });
    tabContent.forEach(function (el) {
      el.classList.remove('active');
    });
    tabLinks[0].classList.add('active');
    tabContent[0].classList.add('active');

  });

  tabLinks.forEach(function (el) {
    el.addEventListener('mouseenter', openTabs); // Change "click" to "mouseenter"
  });

  function openTabs(el) {
    var btnTarget = el.currentTarget;
    var category = btnTarget.dataset.category;

    tabContent.forEach(function (el) {
      el.classList.remove('active');
    });

    tabLinks.forEach(function (el) {
      el.classList.remove('active');
    });

    document.querySelector('#' + category).classList.add('active');
    btnTarget.classList.add('active');
  }

  $('.mob-search').on('click', function () {
    $('.header .header__icons').toggleClass('search-open');
    $(this).toggleClass('active');
    $('.header-wrapper').toggleClass('menu-opened');
  });

  $('.menu-drawer__close a').on('click', function () {
    $(this).parents('#Details-menu-drawer-container').removeClass('menu-opening');
    $(this).parents('#Details-menu-drawer-container').removeAttr('open');
  });

  if ($(document).width() <= 991) {
    $('.hedr-srch input#Search-In-Modal').on('focus', function () {
      $('header').addClass('header-search');
    });

    $('.mob-close').on('click', function () {
      $('header').removeClass('header-search');
    });
  }

});

